import Const from 'const';
import DesktopAdvancedSettings from './desktop/advanced';
import DesktopSimpleSettings from './desktop/simple';
import MobileAdvancedSettings from './mobile/advanced';
import MobileSimpleSettings from './mobile/simple';

const classesMap = {
    desktop: {
        [Const.LEAGUE_NBA]: {
            [Const.GAME_TYPE_CLASSIC]: DesktopAdvancedSettings,
            [Const.GAME_TYPE_SHOWDOWN]: DesktopAdvancedSettings,
            [Const.GAME_TYPE_SINGLEGAME]: DesktopAdvancedSettings,
            [Const.GAME_TYPE_TIERS]: DesktopSimpleSettings,
        },
        [Const.LEAGUE_NFL]: {
            [Const.GAME_TYPE_CLASSIC]: DesktopAdvancedSettings,
            [Const.GAME_TYPE_SHOWDOWN]: DesktopAdvancedSettings,
            [Const.GAME_TYPE_SINGLEGAME]: DesktopAdvancedSettings,
            [Const.GAME_TYPE_TIERS]: DesktopAdvancedSettings,
        },
        others: {
            [Const.GAME_TYPE_CLASSIC]: DesktopAdvancedSettings,
            [Const.GAME_TYPE_SHOWDOWN]: DesktopSimpleSettings,
            [Const.GAME_TYPE_SINGLEGAME]: DesktopSimpleSettings,
            [Const.GAME_TYPE_TIERS]: DesktopSimpleSettings,
        },
    },
    mobile: {
        [Const.LEAGUE_NBA]: {
            [Const.GAME_TYPE_CLASSIC]: MobileAdvancedSettings,
            [Const.GAME_TYPE_SHOWDOWN]: MobileAdvancedSettings,
            [Const.GAME_TYPE_SINGLEGAME]: MobileAdvancedSettings,
            [Const.GAME_TYPE_TIERS]: MobileSimpleSettings,
        },
        [Const.LEAGUE_NFL]: {
            [Const.GAME_TYPE_CLASSIC]: MobileAdvancedSettings,
            [Const.GAME_TYPE_SHOWDOWN]: MobileAdvancedSettings,
            [Const.GAME_TYPE_SINGLEGAME]: MobileAdvancedSettings,
            [Const.GAME_TYPE_TIERS]: MobileAdvancedSettings,
        },
        others: {
            [Const.GAME_TYPE_CLASSIC]: MobileAdvancedSettings,
            [Const.GAME_TYPE_SHOWDOWN]: MobileSimpleSettings,
            [Const.GAME_TYPE_SINGLEGAME]: MobileSimpleSettings,
            [Const.GAME_TYPE_TIERS]: MobileSimpleSettings,
        },
    },
};

class Factory {
    public static getDesktopComponent(sportConfig) {
        return Factory.getComponent('desktop', sportConfig);
    }
    public static getMobileComponent(sportConfig) {
        return Factory.getComponent('mobile', sportConfig);
    }
    private static getComponent(deviceType, sportConfig) {
        const gameType = sportConfig.getGameType().toLowerCase();
        let sport = sportConfig.getSport().toLowerCase();
        if (![Const.LEAGUE_NFL, Const.LEAGUE_NBA].includes(sport)) {
            sport = 'others';
        }

        if (gameType in classesMap[deviceType][sport]) {
            return classesMap[deviceType][sport][gameType];
        }

        throw new Error(`Wrong game type: "${gameType}".`);
    }
}

export {Factory};
